import ClaimOwnershipModal from "./claimOwnership/ClaimOwnershipModal";

export const MODAL_IDS = {
  OWNER_VERIFICATION: "OWNER_VERIFICATION_MODAL",
};

const MODAL_REGISTRY = {
  [MODAL_IDS.OWNER_VERIFICATION]: ClaimOwnershipModal,
};

export default MODAL_REGISTRY;
